import React from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';
import { FONTS } from 'styles/theme/fonts';
import { COLORS } from 'styles/theme/colors';

const ErrorMessage = ({ message, errorColor }) => {
  return (
    <ErrorMessage.ErrorText className="error" errorColor={errorColor}>
      {Array.isArray(message) ? message[0] : message}
    </ErrorMessage.ErrorText>
  );
};

ErrorMessage.ErrorText = styled.span`
  color: ${(props) => props.errorColor || COLORS.primaryErrorText};
  font-size: 10px;
  font-family: ${FONTS.default};
  font-weight: 400;
  text-align: left;
  display: block;
  margin-top: 8px;
`;

ErrorMessage.propTypes = {
  message: PropTypes.oneOfType([PropTypes.string, PropTypes.arrayOf(PropTypes.string)]).isRequired,
  errorColor: PropTypes.string,
};

export default ErrorMessage;
